import classnames from "classnames";
import * as React from "react";

import Checkbox, { CheckboxProps } from "../../Checkbox";
import "./PurpleBackgroundCheckbox.scss";

const PurpleBackgroundCheckbox = (props: CheckboxProps) => {
  return (
    <Checkbox
      {...props}
      checkboxClassName={classnames(
        "PurpleBackgroundCheckbox__checkbox",
        props.checkboxClassName
      )}
      checkboxSelectedClassName="PurpleBackgroundCheckbox__checkbox--checked"
    />
  );
};

export default PurpleBackgroundCheckbox;
